export const ANNOUNCEMENT_CHANNEL = "announcement";
export const ROOM_REQUEST_CHANNEL_PREFIX = "roomrequest";
export const ROOM_NAME_REGEX = /^[a-z0-9_-]+$/i;
export const USERNAME_LENGTH_MAX = 48;
